<template>
  <div style="width:50%;margin:100px auto;">
    <el-form label-width="140px" :model="formData" ref="formData">

      <el-form-item label="联系电话">
        <el-input size="small" style="width:80%" v-model="formData.mobile" class="form-input"></el-input>
      </el-form-item>

      <el-form-item label="邮箱">
        <el-input size="small" style="width:80%" v-model="formData.email" class="form-input"></el-input>
      </el-form-item>

      <el-form-item label="地址">
        <el-input size="small" style="width:80%" v-model="formData.address" class="form-input"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" @click="submitForm()">提交保存</el-button>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
    </div>
  </div>
</template>

<script>
import { config_by_id, config_update, user_refresh_token } from "../api/api";

export default {
  data() {
    return {
      timer: null, // 定时器
      formData: {
        id: 1,
        mobile: "",
        email: "",
        address: ""
      }
    };
  },


  created() {
    // 定时器 start
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer();
    // 定时器 end

    this.queryById(1);
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
  },

  methods: {
    // 定时器
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.refreshToken();
        }, 10 * 60 * 1000)
      }
    },
    async refreshToken() {
      let param = { "page": "config", "token": window.localStorage.getItem("user") }
      const data = await user_refresh_token(param);
      window.localStorage.setItem("user", data.data);
    },
    // 栏目层级列表
    async queryById(id) {
      const data = await config_by_id(id);
      this.formData = data.data;
    },

    // ----------------------add start---------------------
    submitForm() {
      this.update(this.formData);
    },
    async update() {
      await config_update(this.formData);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
    },

    // ----------------------add end-----------------------
  }
};
</script>





// WEBPACK FOOTER //
// src/views/Config.vue